module.exports = __webpack_public_path__ + "static/media/time.16ba5dfe.png";